import { Component, EventEmitter, Inject, Input, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FundService } from '../../services/fund.service';
import { EnumStatusCode } from 'src/app/enum/enumStatusCode';
import { FundSelectList, GetFundTypes } from '../../models/etf';
import { IDPreview } from '../../models/base';
import { mainData } from '../../interface/main-data';
import { DialogData } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-fund-choice',
  templateUrl: './fund-choice.component.html',
  styleUrl: './fund-choice.component.scss'
})
export class FundChoiceComponent {
  @Input() inputFundSelectList: FundSelectList[] = []; // 從外部接收資料
  iDPreview: IDPreview = {} as IDPreview;
  fundSelectList: FundSelectList[] = []; //第二層下拉選單

  @Output() searchEvent = new EventEmitter<{
    selectedFund: FundSelectList | null,
    startDate: Date | null,
    endDate: Date | null
  }>();
  selectedFund: FundSelectList | null = null;
  startDate: Date | null = null;
  endDate: Date | null = null;

  visible: boolean = false;
  visibleType = 0;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    public fundService: FundService,
    public mainData$: mainData,
  ) { }

  ngOnInit(): void {
    // 初始化
  }

  ngOnChanges(changes: SimpleChanges) {
    // 當 inputFundSelectList 改變時執行
    if (changes['inputFundSelectList'] && this.inputFundSelectList && this.inputFundSelectList.length > 0) {
      // 找出"全部"選項
      const allOption = this.inputFundSelectList.find(option =>
        option.FundShortName === '全部' || option.FundFullName === '全部');

      // 如果找到"全部"選項，將其設為預設選擇
      if (allOption) {
        this.selectedFund = allOption;
      } else if (this.inputFundSelectList.length > 0) {
        // 如果沒有找到"全部"選項但列表不為空，選擇第一項
        this.selectedFund = this.inputFundSelectList[0];
      }
    }
  }

  // 當選擇基金時
  onFundChange(event: any) {
    this.selectedFund = event.value;
  }

  // 當選擇開始時間時
  onStartDateChange(event: any) {
    this.startDate = event;
  }

  // 當選擇結束時間時
  onEndDateChange(event: any) {
    this.endDate = event;
  }

  dialogData: DialogData = {} as DialogData;
  // 查詢按鈕點擊時觸發
  search() {
    if (this.startDate && this.endDate && this.startDate > this.endDate) {
      // 顯示錯誤訊息
      this.visible = true;
      this.dialogData.title = '提醒'
      this.dialogData.message = '開始時間不能大於結束時間！';
      return; // 停止執行後續代碼
    }

    // 向父層發送選擇的資料
    this.searchEvent.emit({
      selectedFund: this.selectedFund,
      startDate: this.startDate,
      endDate: this.endDate
    });
  }

  visibleChange(e: any) {
    this.visible = false;
  }
}
